import { Controller } from '@hotwired/stimulus'
import { put } from '../lib/request'

export default class extends Controller {
  static values = {
    url: String,
    enabled: Boolean,
    id: Number,
  }

  async updateEnabled() {
    const enabled = this.enabledValue
    const params = {
      default_print_type: {
        enabled: enabled,
      },
    }

    await put(this.urlValue, { body: JSON.stringify(params), responseKind: 'turbo-stream' })
  }
}
